import type { FormatMoney } from './FormatService';

/** Locale-aware money display helpers (major units, e.g. dollars not cents). */
export function createFormatMoney(locale: string): FormatMoney {
  const formatAmountOrNull = (
    amount: number,
    currency: string
  ): string | null => {
    if (!Number.isFinite(amount)) {
      return null;
    }
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency || 'USD'
    }).format(amount);
  };

  return {
    formatAmountOrNull,
    formatAmount: (amount, currency) =>
      formatAmountOrNull(amount, currency) ?? '',
    format: value => formatAmountOrNull(value.amount, value.currency) ?? ''
  };
}
